
import * as moment from 'moment';

export function toUTCSmallDate(date?: any) {
    let d: Date;
    if (date && date instanceof Date) {
      d = date;
    } else if (date && date.hasOwnProperty("_isAMomentObject")) {
      d = (date as moment.Moment).toDate();
    } else {
      d = (!date || !date.length) ? new Date() : new Date(date);
    }
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0));
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/dates.service.ts